import { Stack, Group, Select, TextInput } from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import { IconSearch, IconCalendar } from '@tabler/icons-react';

export interface AuditFilter {
  status?: string;
  searchTerm?: string;
  dateRange?: {
    start: Date | null;
    end: Date | null;
  };
}

interface AuditFilterContentProps {
  filters: AuditFilter;
  onFiltersChange: (filters: AuditFilter) => void;
}

export function AuditFilterContent({ filters, onFiltersChange }: AuditFilterContentProps) {
  return (
    <Stack gap="md">
      <TextInput
        placeholder="Search by audit name"
        leftSection={<IconSearch size={16} />}
        value={filters.searchTerm || ''}
        onChange={(e) =>
          onFiltersChange({
            ...filters,
            searchTerm: e.target.value || undefined,
          })
        }
      />

      <Select
        label="Status"
        placeholder="All statuses"
        clearable
        data={[
          { value: 'draft', label: 'Draft' },
          { value: 'in_progress', label: 'In Progress' },
          { value: 'completed', label: 'Completed' },
          { value: 'cancelled', label: 'Cancelled' },
        ]}
        value={filters.status}
        onChange={(value) =>
          onFiltersChange({ ...filters, status: value || undefined })
        }
      />

      <Group grow>
        <DatePickerInput
          label="Audit Date From"
          placeholder="Select start date"
          leftSection={<IconCalendar size={16} />}
          clearable
          value={filters.dateRange?.start || null}
          onChange={(date) =>
            onFiltersChange({
              ...filters,
              dateRange: {
                start: date,
                end: filters.dateRange?.end || null,
              },
            })
          }
        />
        <DatePickerInput
          label="Audit Date To"
          placeholder="Select end date"
          leftSection={<IconCalendar size={16} />}
          clearable
          value={filters.dateRange?.end || null}
          onChange={(date) =>
            onFiltersChange({
              ...filters,
              dateRange: {
                start: filters.dateRange?.start || null,
                end: date,
              },
            })
          }
        />
      </Group>
    </Stack>
  );
}
